<template>
  <div class="mb-5">
    <div v-if="getNaviMode === 'edit'">
      <span class="edit-syaryo-title">車両情報編集中</span>
    </div>
    <div v-else-if="getNaviMode === 'irekae'">
      <span class="edit-syaryo-title">下取り/入れ替え車両入力中</span>
    </div>
    <ol v-else class="step">
      <li
        v-for="(val, tabName) in tabs"
        :key="val.index"
        :class="[
          'text-center',
          { first: tabId === '1' },
          getTabClassAndSetPassedFlg(tabName),
        ]"
      >
        <em>{{ tabs[tabName].icon }}{{ $t(`order.tabs.${tabName}`) }}</em>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'Navi',

  props: {
    /** タブID */
    tabId: {
      type: String,
      default: null,
    },

    /** 入力form */
    form: {
      type: Object,
      default: null,
    },

    /** 入力モード */
    mode: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    tabs: {
      transport: {
        index: '1',
        icon: '❶',
        to: 'Transport',
        passedFlg: false,
      },
      vehicle: {
        index: '2',
        icon: '❷',
        to: 'Vehicle',
        passedFlg: false,
      },
      confirm: {
        index: '3',
        icon: '❸',
        to: 'Confirm',
        passedFlg: false,
      },
      complete: {
        index: '4',
        icon: '❹',
        to: 'Complete',
        passedFlg: false,
      },
    },
  }),
  methods: {
    getTabClassAndSetPassedFlg(tabName) {
      let tab = this.tabs[tabName]
      let className = 'is-passed'
      let passedFlg = true
      if (tab.index === this.tabId) {
        className = 'is-current'
        passedFlg = false
      } else if (tab.index > this.tabId) {
        className = ''
        passedFlg = false
      }
      tab.passedFlg = passedFlg
      return className
    },
    getRouterName(name) {
      return this.form.MEIHEN_FLG ? `OrderMeihen${name}` : `Order${name}`
    },
    _back(isPassed) {
      if (isPassed) {
        this.$emit('back')
      }
    },
  },
  computed: {
    getNaviMode() {
      let mode = this.mode
      if (!mode) {
        mode = 'default'
        if (this.form.isIrekae) mode = 'irekae'
        else if (this.form.isFromHistoryEdit) mode = 'edit'
      }
      return mode
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.edit-syaryo-title
  font-weight: bold
  font-size: 40px
  color: red
  //animation: flash 2s linear infinite
  @keyframes flash
    0%,100%
      opacity: 1
    50%
      opacity: 0
.step
  list-style-type: none
  display: table
  min-height: 45px
  width: 80%
  padding: 0
  margin: 0
  overflow: hidden
  @include tablet
    font-size: 16px
    width: 100%
  @include sp
    font-size: 12px
    width: 100%
  li
    display: table-cell
    position: relative
    padding: 0 0.5em 0 2em
    background: #504944
    color: #fff
    @include sp
      padding: 0.8em 0.5em 0.8em 1em
    &:last-child
      padding-right: 1em
    &:last-child:before,
    &:last-child:after
      display: none
    &:before,
    &:after
      content: ""
      position: absolute
      width: 0
      height: 0
      margin: auto
    &:before
      top: -15px
      right: -1em
      border-style: solid
      border-color: transparent transparent transparent #fff
      border-width: 40px 0 40px 1em
      z-index: 10
    &:after
      top: -15px
      right: -.8em
      border-style: solid
      border-color: transparent transparent transparent #504944
      border-width: 40px 0 40px 1em
      z-index: 10
    &.is-passed
      background: #6495ed
      font-weight: bold
      //cursor: pointer
      @include sp
        padding: 0
    &.is-current
      background: $baseBlueColor
      font-weight: bold
      padding-top: 10px
    &.is-passed:after
      border-color: transparent transparent transparent #6495ed
    &.is-current:after
      border-color: transparent transparent transparent $baseBlueColor
    //&.is-passed
    //  &:hover
    //    background: $baseBlueColor
    //    &:after
    //      border-left-color: $baseBlueColor
    a
      display: block
      padding: 0.8em 0
      color: white
      //&:hover
      //  color: white
      //@include sp
      //  padding: 0.8em 0.5em 0.8em 1em
  li.first
    padding: 0.8em 0.5em 0.8em 2em
    @include sp
      padding: 0.8em 0.5em 0.8em 1em
</style>



// WEBPACK FOOTER //
// src/components/order/Navi.vue